module.exports = __webpack_public_path__ + "img/quotation_dark.fd8ab95b.svg";